import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';

@Component({
  selector: 'app-add-cancellation-policy',
  templateUrl: './add-cancellation-policy.component.html',
  styleUrls: ['./add-cancellation-policy.component.css']
})
export class AddCancellationPolicyComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
